import { defineMessages } from 'react-intl-next';
import { anchorConstructor, paragraphConstructor } from './utils';

const values = {
	a: anchorConstructor,
	p: paragraphConstructor,
};
const messages = defineMessages({
	yourProjectPagesInJiraTitle: {
		id: 'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title',
		defaultMessage: 'Your project pages, directly in Jira',
		description: '',
		values,
	},
	yourProjectPagesInJiraDescription: {
		id: 'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description',
		defaultMessage: `
        <p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p>
        <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>
    `,
		description: '',
		values,
	},
	seamlesslyUpdateStakeholdersTitle: {
		id: 'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title',
		defaultMessage: 'Seamlessly update your stakeholders',
		description: '',
		values,
	},
	seamlesslyUpdateStakeholdersDescription: {
		id: 'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description',
		defaultMessage: `
        <p>Keep your project reports up-to-date with auto-updating status labels.</p>
        <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>
    `,
		description: '',
		values,
	},
	unifyDocumentationTitle: {
		id: 'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title',
		defaultMessage: 'Unify your documentation standards',
		description: '',
		values,
	},
	unifyDocumentationDescription: {
		id: 'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description',
		defaultMessage: `
        <p>Create consistent documentation by using our built-in templates. They are simple to use and customizable for your needs.</p>
        <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>
    `,
		description: '',
		values,
	},
});

export default messages;
